// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "co.lifedefi",
    name: "Life DeFi",
    homepage: "https://lifedefi.co",
    image_id: "d249af4f-e9b8-498d-cbc3-9eab04568700",
    app: {
        browser: null,
        ios: "https://apps.apple.com/ca/app/life-the-defi-wallet/id1591427970",
        android: "https://play.google.com/store/apps/details?id=life.lifecrypto.app&hl=en_US&gl=US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "w3akvrn:/",
        universal: null,
    },
    desktop: {
        native: "w3akvrn:/",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map